class FieldKind {
	static REGULAR = 'REGULAR';
	static COLLECTION = 'COLLECTION';
	static DYNAMIC = 'DYNAMIC';
	static MAP = 'MAP'
}

export default FieldKind;
